/* projects/erp/src/app/shared/components/scroll-navigation/scroll-navigation.component.scss */
:host {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.scroll-up-button {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.28);
}
.scroll-down-button {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.28);
}
@media (max-width: 599px) {
  :host {
    right: 16px;
    bottom: 16px;
  }
}
/*# sourceMappingURL=scroll-navigation.component.css.map */
